export default "__VITE_PUBLIC_ASSET__93e816ad__"